"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line


var Block = function Block(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    maxWidth: "lg",
    component: "section"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    py: 4
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    maxWidth: "md",
    style: {
      marginRight: '100%'
    }
  }, children)));
};

var _default = Block;
exports["default"] = _default;